import {
  useBjelinTranslations,
  useProductTranslations
} from "../../hooks/TranslationHooks";
import FormattedPrice from "../FormattedPrice";
import { useProductUrl } from "../../utils/ProductUtils";
import { divide } from "../../utils/NumberUtils";
import { addVat } from "../../utils/VatUtils";
import { useUser } from "../../functional-components/UserContext";
import { Link } from "react-router-dom";
import ImageOrVideo from "../ImageOrVideo";
import IconsOrTagline from "../IconsOrTagline";
import Icon from "../Icon";
import { cmsUrl } from "../../utils/CmsUtils";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import useShowPricesWithVat from "../../hooks/useShowPricesWithVat";
import { Flags } from "../Flags";
import ProductReplacedByArea from "../ProductPurchaseColumn/ProductReplacedByArea";
import { useProductTypeById, useSetting } from "../../hooks/SettingsHooks";
import { useProductPrice } from "../../hooks/ProductHooks";
import "./style.scss";

const ProductWell = ({ product, children }) => {
  const features = useSiteFeatures();
  const tp = useProductTranslations();
  const t = useBjelinTranslations();
  const { admin, b2b } = useUser();
  const productUrl = useProductUrl(product);
  const showPricesWithVat = useShowPricesWithVat();
  const {
    purchasable,
    basePrice,
    unitPrice,
    unitDisplayPrice,
    priceUnit,
    isPerSquareMeter,
    previousBasePrice,
    currency,
    unitQuantityFactor
  } = useProductPrice(product, b2b);

  const {
    sku,
    images,
    specsIndexed,
    tagline,
    productType: productTypeId
  } = product;

  const productBasePrice = basePrice ? (
    <FormattedPrice
      price={showPricesWithVat ? addVat(basePrice) : basePrice}
      sales_unit={priceUnit}
      currency={currency}
      price_class_name={!isPerSquareMeter ? "big-price" : null}
    />
  ) : null;
  const productUnitPrice =
    unitPrice && isPerSquareMeter ? (
      <FormattedPrice
        price={unitDisplayPrice}
        price_class_name={"big-price"}
        price_unit={priceUnit}
        currency={currency}
      />
    ) : null;
  const previousUnitPrice =
    previousBasePrice > 0 && isPerSquareMeter ? (
      <FormattedPrice
        price={addVat(divide(previousBasePrice, unitQuantityFactor))}
        price_unit={priceUnit}
        currency={currency}
      />
    ) : null;

  const productType = useProductTypeById(productTypeId);
  const hiddenSpecs = useSetting("hidden_specifications", []);
  const iconSpecs = (
    Array.isArray(productType?.specifications_as_icons)
      ? productType.specifications_as_icons
      : []
  ).filter(field => !hiddenSpecs.includes(field));
  const iconSpecsIndexed = specsIndexed
    ? Object.fromEntries(
        Object.entries(specsIndexed).filter(([field]) =>
          iconSpecs.includes(field)
        )
      )
    : {};

  const themeClassName = "theme-smoke";

  const image = {
    ...images[0],
    path: cmsUrl(images[0].path)
  };

  return (
    <div className="cockpit-herowell product-well">
      <ImageOrVideo image={image} style={{ zIndex: -1 }} />
      <div className={"cockpit-herowell-content"}>
        <div className={`cockpit-herowell-well ${themeClassName}`}>
          <Flags product={product} inline={false} />
          <h2>
            <span>{product.name}</span>{" "}
          </h2>
          <p className={"article-number"}>
            {tp("article_number")}: {sku}
          </p>
          <div className={"tagline"}>
            <IconsOrTagline
              specsIndexed={iconSpecsIndexed}
              showLabel
              sku={sku}
              tagline={tagline}
            />
          </div>{" "}
          {features.prices() && purchasable && (
            <div className={"prices"}>
              {productUnitPrice && (
                <div className={"unit-price"}>
                  {productUnitPrice}
                  {previousUnitPrice && (
                    <div className={"previous-unit-price"}>
                      {tp("previous_unit_price")}
                      {previousUnitPrice}
                    </div>
                  )}
                </div>
              )}
              <div className={"price"}>{productBasePrice}</div>
              <div className={"price-info"}>({tp("price_incl_vat")})</div>
            </div>
          )}
          <div className="cockpit-bjelin_button" style={{ margin: "2em 0" }}>
            <Link
              className={purchasable ? "button-primary" : "button-outlined"}
              to={productUrl}
            >
              {t(purchasable ? "buy.online" : "show.product")}{" "}
              <Icon name={"chevron-right"} />
            </Link>
          </div>
          <ProductReplacedByArea product={product} />
          {admin && product.tags && (
            <p className={"article-number"}>
              {product.tags.map(tag => (
                <span key={tag} style={{ marginRight: "1em" }}>
                  <Icon type={"far"} name={"tag"} /> {tag}
                </span>
              ))}
            </p>
          )}
          {/*purchasable && <ProductStock product={product} b2b={b2b} />*/}
          {children}
        </div>
      </div>
    </div>
  );
};

export default ProductWell;
